// extracted by mini-css-extract-plugin
export var $animation_name = "Cta-module--$animation_name--3bd50";
export var Cta = "Cta-module--Cta--ed5e0";
export var Cta__inner = "Cta-module--Cta__inner--a90d0";
export var Cta__link = "Cta-module--Cta__link--7eb9c";
export var Cta__link__title = "Cta-module--Cta__link__title--62149";
export var disabled = "Cta-module--disabled--a5f82";